import React from 'react';

import { ReactComponent } from '../../../../../shared/abstract/infrastructrue/ReactComponent';
import {
  TUnifiedRole,
  TUnifiedRolesMap,
} from '../../../../UnifiedRoles/domain/interfaces';
import {
  IUserTenantSpecificRolesCheckboxCreator,
  TUserTenantSpecificRolesCheckbox,
} from '../../../domain/interfaces';
import { UseTenantSpecificRolesCheckbox } from './UserTenantSpecificRolesCheckbox.view';

export class UserTenantSpecificRolesCheckbox extends ReactComponent {
  public isUnifiedRoleAssignedToUser(
    tenantSpecificUnifiedRole: TUnifiedRole,
    userAssignedTenantSpecificRoles: TUnifiedRolesMap,
  ): boolean {
    return !!userAssignedTenantSpecificRoles.get(tenantSpecificUnifiedRole.id);
  }

  public isNotAvailableAsTenantSpecificRole(
    tenantSpecificUnifiedRole: TUnifiedRole,
    userAssignedTenantSpecificRoles: TUnifiedRolesMap,
    availableTenantAgnosticRoles: TUnifiedRolesMap,
  ): boolean {
    return (
      !userAssignedTenantSpecificRoles.has(tenantSpecificUnifiedRole.id) &&
      availableTenantAgnosticRoles.has(tenantSpecificUnifiedRole.id)
    );
  }

  public static create({
    isApiRequestInProgress,
    userPrincipal,
    unifiedRole,
    assignedUserTenantSpecificRolesState,
    uiUserTenantSpecificRoles,
    availableTenantAgnosticRoles,
  }: IUserTenantSpecificRolesCheckboxCreator): React.ReactElement<TUserTenantSpecificRolesCheckbox> {
    const {
      userTenantSpecificRolesEditor: {
        canUserPrincipalUpdateTenantSpecificUnifiedRoles,
        addUnifiedRole,
        removeUnifiedRole,
      },
    } = uiUserTenantSpecificRoles;

    const isEditableByUserPrincipal =
      canUserPrincipalUpdateTenantSpecificUnifiedRoles(userPrincipal);

    const withLoadingStatus: React.FC<TUserTenantSpecificRolesCheckbox> =
      this.composeWithLoadingStatus<TUserTenantSpecificRolesCheckbox>(
        UseTenantSpecificRolesCheckbox,
        {
          withLoadingStatusOptions: {
            isLoading: isApiRequestInProgress,
            css: {
              h: '21px',
              w: '21px',
            },
          },
        },
      );

    return this.withAnyOfPermissionsHOC<TUserTenantSpecificRolesCheckbox>(
      ['system-admin:read:tenant-specific-user-role-assignments'],
      withLoadingStatus,
      {
        config: new UserTenantSpecificRolesCheckbox(),
        user: userPrincipal,
        isApiRequestInProgress,
        availableTenantAgnosticRoles,
        unifiedRole,
        assignedUserTenantSpecificRolesState,
        isEditableByUserPrincipal,
        handleAddRole: addUnifiedRole,
        handleRemoveRole: removeUnifiedRole,
      },
    );
  }
}
